<template>
  <div class='manage'>
    <!-- 页面顶部板块 -->
    <div class="top">
      <el-header>
        <Head-top></Head-top>
      </el-header>
    </div>
    <el-container style="padding-left:10px">
      <!-- 页面左侧菜单板块 -->
      <div class="sidebar" :style="'background:linear-gradient(' + colorChange.top + ',' + colorChange.button + ');'">
        <el-aside class="z-aside">
          <el-menu
            :collapse="isCollapse"
            class="el-menu-vertical-demo"
            text-color="#fff"
            active-text-color="#ffd04b"
            :unique-opened="true"
            :default-active="open_menu"
            :default-openeds="openeds"
            >
            <template v-for="subItem in menuList">
              <el-submenu v-if="subItem.children && subItem.children.length != 0" :key="subItem.id" :index="subItem.name + ''">
                <template slot="title">
                  <i v-for="item in $t('lang.menu')" :key="item.name">
                    <i v-if="item.name === subItem.id" class="iconfont" :class="item.url"></i>
                  </i>
                  <span slot="title">
                    {{ subItem.name }}
                  </span>
                </template>
                <el-menu-item :draggable="true" :index="items.id + ''" @click="routeJump(items.route, items.name)" v-for="items in subItem.children" :key="items.id">
                  <span slot="title">{{ items.name }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </el-aside>
        <div class="hiddenBtn" :style="'background: linear-gradient(90deg,' + colorChange.button + ',' + colorChange.top + ');'" @click="isCollapse = false" v-if="isCollapse">
          <i class="el-icon-arrow-left iconicon"></i>
        </div>
        <div class="hiddenBtn" :style="'background: linear-gradient(90deg,' + colorChange.button + ',' + colorChange.top + ');'" @click="isCollapse = true" v-if="!isCollapse">
          <i class="el-icon-arrow-right iconicon"></i>
        </div>
      </div>
      <!-- 页面内容body -->
      <el-container class="frame-body">
        <!-- tabs的操作栏 -->
        <el-dropdown @command="handleCommand" class="closeTabs" v-if="editableTabs.length > 0">
          <span class="el-dropdown-link">
            {{$t('lang.lab_operation')}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">{{$t('lang.lab_closeNow')}}</el-dropdown-item>
            <el-dropdown-item command="b">{{$t('lang.lab_closeAll')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 页面tabs显示位置， 要把el-main包起来，或者在el-main里面都行 -->
        <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="jumpOtherTabs(editableTabsValue)" :lazy="true">
          <el-tab-pane
            :key="item.route"
            v-for="item in editableTabs"
            :label="item.title"
            :name="item.route">
          </el-tab-pane>
        </el-tabs>
        <!-- 切换tabs时页面被执行多次 -->
        <el-main>
          <router-view :key="key"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import HeadTop from '../components/headTop'
  import { menus } from '../router/router'
  import { mapState } from 'vuex'
  export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'Manage',
    components: {
      HeadTop
    },
    data() {
      return {
        allMenu: menus, // route的list
        menuList: [],
        menuLists: [],
        defaultActive: '/manage',
        colorChange: {}, // 主题切换更换class
        myGardens: [], // 全部小区列表
        myGarden: 0, // 全部小区绑定
        editableTabsValue: 'homePage',
        editableTabs: [{
          title: '首页',
          route: 'homePage'
        }],
        openeds: [],
        tabIndex: 0,
        changeGardens: '',
        nowTabs: '', // 当先显示的tabs
        isCollapse: false, // 默认菜单显示
        tabsCount: '0',
        open_menu: '', // 展开的一级菜单
        query: {}, // 记录新路由后的query
      }
    },
    // 监听属性 类似于data概念
    computed: {
      ...mapState({
        showSettings: state => state.settings.showSettings
      }),
      key() {
        console.log(this.$route)
        return this.$route.path + Math.random()
      }
    },
    // 监控data中的数据变化
    watch: {
    '$store.state.colorChange': function (newFlag, oldFlag) {
      this.colorChange = this.$store.state.colorChange
    },
    '$store.state.tabList': function (newFlag, oldFlag) {
      this.editableTabs = this.$store.getters.getTabList
    },
    // 监听tab的列表
    editableTabs: {
      handler: function(val, oldVal) {
        window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
      },
      deep: true
    },
    // 监听tab列表的选中态
    editableTabsValue: {
      handler: function(val, oldVal) {
        window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
      },
      deep: true
    },
    // 监听菜单的选中态
    open_menu: {
      handler: function(val, oldVal) {
        window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
      },
      deep: true
    },
    // 监听路由
    $route: {
      handler: function(val, oldVal) {
        if (navigator.onLine || window.navigator.onLine === true) {
          // 记录下是否有参数
          this.query = val.query
          if (oldVal.name === 'homePage') {
            // 从首页跳转执行routeJump方法，添加tab页
            // 在首页跳转时，修正tab不选中bug
            let changeRoute = val.path.split('/manage/')
            this.routeJump(changeRoute[1], val.meta.name)
          }
          // 循环查找路由名称，相等就切换菜单的选中态
          for (var j = 0; j < this.editableTabs.length; j++) {
            if (this.editableTabs[j].title === val.meta.name) {
              this.editableTabsValue = this.editableTabs[j].route
            }
          }
          // 需要跳转到新tab的页面
          if (val.name === 'houseHoldInfo' || val.name === 'personalInfo' || val.name === 'fullprojectAutoInspecRepoBackgroundDetail' || val.name === 'projectWideRepoInfoBackgroundDetail' || val.name === '400backgroundDetail' || val.name === 'repoInfoBackgroundDetail' || val.name === 'liftManagementInfo' || val.name === 'editPreInfo' || oldVal.name === 'projectCalendarList' || oldVal.name === 'editTask' || val.name === 'trialOrderDetail' || oldVal.name === 'hawkEyeOfParkList') {
            // 已经存在tabs准备跳转
            let isJump = false
            // 循环tabs列表，判断是否已经存在tab了
            for (var i = 0; i < this.editableTabs.length; i++) {
              if (this.editableTabs[i].title === val.meta.name) {
                isJump = true
              }
            }
            if (isJump) {
              if (!JSON.parse(window.localStorage.getItem('userData'))) {
                this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                this.$router.push({ name: 'login' })
              } else {
                this.$router.push({ name: val.name, query: this.query })
                this.editableTabsValue = val.path
                window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
              }
            } else {
              if (!JSON.parse(window.localStorage.getItem('userData'))) {
                this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                this.$router.push({ name: 'login' })
              }
              if (this.editableTabs.length >= 10) {
                this.$message.error('最多只能打开10个标签页，如要打开请先关闭')
                this.$router.push({ name: oldVal.name })
              } else {
                this.editableTabs.push({
                  title: val.meta.name,
                  route: val.path,
                  query: val.query
                })
                window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
                this.$router.push({ name: val.name, query: this.query })
                this.editableTabsValue = val.path
                window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
              }
            }
          }
          if (!JSON.parse(window.localStorage.getItem('userData'))) {
            this.$message.error(this.$i18n.t('lang.lab_notOnload'))
            this.$router.push({ name: 'login' })
          }
          var menuId
          var aaa
          if (this.menuList.length > 0) {
            this.menuList.filter(function (item, index) {
              if (item.children && item.children.length > 0) {
                item.children.filter(function (items, indexs) {
                  if (items.name === val.meta.name || items.route === val.matched[val.matched.length - 2].path.split('/manage/')[1]) {
                    menuId = items.id
                    aaa = items.id
                  }
                })
              }
            })
            this.open_menu = menuId + ''
            if (val.matched && oldVal.matched && val.matched.length > 2 && oldVal.matched.length > 2 && val.matched[val.matched.length - 2].name === oldVal.matched[val.matched.length - 2].name) {
              this.open_menu = aaa + ''
            }
          }
          if (val.name === 'homePage') {
            this.open_menu = 'homePage'
          }
          window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
        } else {
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }
      },
      deep: true
    },
  },
    // 方法集合
    methods: {
      // 点击关闭标签
      removeTab(targetName) {
        if (navigator.onLine || window.navigator.onLine === true) {
          if (targetName != 'homePage') {
            let tabs = this.editableTabs
            let activeName = this.editableTabsValue
            if (activeName === targetName) {
              tabs.forEach((tab, index) => {
                if (tab.route === targetName) {
                  let nextTab = tabs[index + 1] || tabs[index - 1]
                  if (nextTab) {
                    activeName = nextTab.route
                  }
                }
              })
            }
            this.editableTabsValue = activeName
            window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
            for (var j = 0; j < this.editableTabs.length; j++) {
              if (this.editableTabs[j].route == this.editableTabsValue) {
                this.$router.push({ path: this.editableTabs[j].route, query: this.editableTabs[j].query })
              }
            }
            if (this.editableTabs.length === 1) {
              this.$router.push({ path: 'homePage' })
            }
            this.tabIndex--
            this.editableTabs = tabs.filter(tab => tab.route != targetName)
            window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
          } else {
            this.$message.error('您还没有打开标签!')
          }
        } else {
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }
      },
      // 点击切换按钮，更改路由跳转
      jumpOtherTabs(route) {
        if (navigator.onLine || window.navigator.onLine === true) {
            let isJump = false
          for (var i = 0; i < this.editableTabs.length; i++) {
            if (this.editableTabs[i].route === this.editableTabsValue) {
              var newQuery = this.editableTabs[i].query
              if (this.editableTabs[i].query && this.editableTabs[i].query != '') {
                this.$router.push({ path: route, query: this.editableTabs[i].query })
              } else {
                this.$router.push({ path: route, query: this.editableTabs[i].query })
              }
            }
          }
          if (isJump) {
            if (!JSON.parse(window.localStorage.getItem('userData'))) {
              this.$message.error(this.$i18n.t('lang.lab_notOnload'))
              this.$router.push({ path: '' })
            } else {
              this.$router.push({ path: route, query: newQuery })
            }
          }
          var menuId
          this.menuList.filter(function (item, index) {
            if (item.children && item.children.length > 0) {
              item.children.filter(function (items, indexs) {
                if (items.route === route) {
                  menuId = items.id
                }
              })
            }
          })
          this.open_menu = menuId + ''
          window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
          if (!JSON.parse(window.localStorage.getItem('userData'))) {
            this.$message.error(this.$i18n.t('lang.lab_notOnload'))
            this.$router.push({ name: 'login' })
          }
        } else {
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }
      },
      // 点击左侧菜单跳转
      routeJump(path, name) {
        if (navigator.onLine || window.navigator.onLine === true) {
          // 判断是否存在tabs
          var isExistence = true
          // 已经存在tabs准备跳转
          let isJump = false
          // 循环tabs列表，判断是否已经存在tab了
          for (var i = 0; i < this.editableTabs.length; i++) {
            if (this.editableTabs[i].title === name) {
              var newQuery = this.editableTabs[i].query
              isExistence = false
              isJump = true
            }
          }
          if (isJump) {
            for (var j = 0; j < this.editableTabs.length; j++) {
              if (this.editableTabs[j].title === name) {
                this.editableTabsValue = this.editableTabs[j].route
              }
            }
            if (!JSON.parse(window.localStorage.getItem('userData'))) {
              this.$message.error(this.$i18n.t('lang.lab_notOnload'))
              this.$router.push({ name: 'login' })
            } else {
              this.$router.push({ path: path, query: newQuery })
              this.editableTabsValue = path
              window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
            }
          } else {
            if (isExistence) {
              if (this.editableTabs.length >= 10) {
                this.$message.error(this.$i18n.t('lang.lab_openTenMax'))
              } else {
                if (!JSON.parse(window.localStorage.getItem('userData'))) {
                  this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                  this.$router.push({ name: 'login' })
                } else {
                  this.editableTabs.push({
                    title: name,
                    route: path,
                    query: newQuery
                  })
                  window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
                  this.editableTabsValue = path
                  window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
                  this.$router.push({ path: path, query: newQuery })
                }
              }
            }
          }
          var menuId
          this.menuList.filter(function (item, index) {
            if (item.children && item.children.length > 0) {
              item.children.filter(function (items, indexs) {
                if (items.name === name) {
                  menuId = items.id
                }
              })
            }
          })
          this.open_menu = menuId + ''
          window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
        } else {
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }
      },
      // tabs操作栏
      handleCommand(command) {
        if (navigator.onLine || window.navigator.onLine === true) {
            if (command === 'a') {
            this.removeTab(this.editableTabsValue)
          } else if (command === 'b') {
            // 关闭所有tabs
            this.editableTabs = [{
              title: '首页',
              route: 'homePage'
            }]
            this.$router.push({ path: 'homePage' })
            this.editableTabsValue = 'homePage'
            window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
          }
        } else {
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }
      },
      // 页面加载时候转换路由
      changeRouter() {
        const pathStr = JSON.parse(JSON.stringify(this.$route.path))
        if (pathStr.indexOf('=') === -1) {
          var pathArr = pathStr.split('/')
          if (pathArr.length > 3) {
            pathArr.splice(pathArr.length - 1, 1)
            var activeStr = pathArr.join('/')
            this.defaultActive = activeStr
          } else {
            pathArr.splice(pathArr.length - 1, 1)
            var activeStrr = pathArr.join('/')
            this.defaultActive = activeStrr
          }
        } else {
          var pathNewArr = pathStr.split('=')
          pathNewArr.splice(pathNewArr.length - 1, 1)
          var activeNewStr = pathNewArr.join('=')
          this.defaultActive = activeNewStr
        }
        // if (!JSON.parse(window.localStorage.getItem('userData'))) {
        //   this.$message.error(this.$i18n.t('lang.lab_notOnload'))
        //   this.$router.push({ name: 'login' })
        // }
      },
      checkLogin() {
        if (localStorage.getItem('userGardenList') && localStorage.getItem('userMunuList') && localStorage.getItem('changeGardens')) {
          this.myGardens = JSON.parse(localStorage.getItem('userGardenList')) // 获取localStorage里的小区权限
          if (JSON.parse(localStorage.getItem('userGardenList')) && JSON.parse(localStorage.getItem('userGardenList')).length === 0) {
            this.myGardens = [{
              id: 1,
              name: this.$i18n.t('lang.lab_noGarden')
            }]
            this.myGarden = 1
            this.$store.commit('setGardenId', this.myGarden)
          } else {
            if (JSON.parse(localStorage.getItem('userGardenList')).length > 0 && JSON.parse(localStorage.getItem('userGardenList'))[0].id === 0) {
              this.myGarden = 0
              this.$store.commit('setGardenId', this.myGarden)
            } else {
              this.myGarden = JSON.parse(localStorage.getItem('userGardenList'))[0].id
              this.$store.commit('setGardenId', this.myGarden)
            }
          }
          this.menuLists = JSON.parse(localStorage.getItem('userMunuList')) // 获取localStorage里的菜单权限
          this.changeGardens = JSON.parse(localStorage.getItem('changeGardens')) // 获取localStorage里的菜单切换
          if (this.menuLists.length === 1) {
            this.menuList = this.menuLists[0]
          }
          if (this.menuLists.length > 1) {
            this.menuList = this.menuLists[this.changeGardens]
          }
          for (var i = 0; i < this.menuList.length; i++) {
            if (this.menuList[i].children && this.menuList[i].children.length > 1) {
              for (var j = 0; j < this.menuList[i].children.length; j++) {
                if (this.menuList[i].children[j].route.indexOf('orgDepartment') != -1) {
                  this.menuList[i].children[j].route = 'main.orgDepartment'
                }
                if (this.menuList[i].children[j].route.indexOf('pivot') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('0') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot0'
                  }
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot1'
                  }
                  if (this.menuList[i].children[j].route.indexOf('2') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot2'
                  }
                  if (this.menuList[i].children[j].route.indexOf('3') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot3'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('gardenvacant') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.gardenvacant1'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('garden(') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.garden1'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('maintainType') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.maintainType1'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('contractType') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.contractType1'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('paidServiceType') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.paidServiceType1'
                  }
                }
              }
            }
          }
        } else {
          this.$message.error(this.$i18n.t('lang.lab_notOnload'))
          this.$router.push({ name: 'login' })
        }
        console.log(this.menuList)
      },
      // 更换小区下拉
      changeGarden() {
        this.openeds = ['1']
        this.open_menu = 'homePage'
        if (this.menuLists.length > 1) {
          if (this.myGarden === 0) {
            this.menuList = this.menuLists[1]
            this.$store.commit('setGardenId', this.myGarden)
            this.editableTabs = [{
              title: '首页',
              route: 'homePage',
              close: 'closable'
            }]
            this.$router.push({ path: 'homePage' })
            this.editableTabsValue = 'homePage'
          } else {
            this.menuList = this.menuLists[0]
            for (var i = 0; i < this.menuList.length; i++) {
            if (this.menuList[i].children && this.menuList[i].children.length > 1) {
              for (var j = 0; j < this.menuList[i].children.length; j++) {
                if (this.menuList[i].children[j].route.indexOf('pivot') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('0') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot0'
                  }
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot1'
                  }
                  if (this.menuList[i].children[j].route.indexOf('2') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot2'
                  }
                  if (this.menuList[i].children[j].route.indexOf('3') != -1) {
                    this.menuList[i].children[j].route = 'main.pivot3'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('gardenvacant') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.gardenvacant1'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('garden(') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.garden1'
                  }
                }
                if (this.menuList[i].children[j].route.indexOf('contractType') != -1) {
                  if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                    this.menuList[i].children[j].route = 'main.contractType1'
                  }
                }
              }
            }
          }
            this.editableTabs = [{
              title: '首页',
              route: 'homePage',
              close: 'closable'
            }]
            this.$router.push({ path: 'homePage' })
            this.editableTabsValue = 'homePage'
            this.$store.commit('setGardenId', this.myGarden)
          }
        } else {
          this.menuList = this.menuLists[0]
          this.editableTabs = [{
            title: '首页',
            route: 'homePage',
            close: 'closable'
          }]
          this.$router.push({ path: 'homePage' })
          this.editableTabsValue = 'homePage'
          this.$store.commit('setGardenId', this.myGarden)
        }
        window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
        window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
      },
    },
    // 加判断，localStorage是否为空，空跳转登录页
    created() {
      this.checkLogin()
      this.colorChange = this.$store.getters.getColorChange
      this.open_menu = 'homePage'
      if (JSON.parse(localStorage.getItem('tableTabs'))) {
        this.editableTabs = JSON.parse(localStorage.getItem('tableTabs'))
        this.editableTabsValue = JSON.parse(localStorage.getItem('tabsValue'))
        this.open_menu = JSON.parse(localStorage.getItem('openMenu'))
      }
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.changeRouter()
    },
    // 如果页面有keep-alive缓存功能，这个函数会触发
    activated() {}
  }
</script>

<style lang='scss'>
  .manage {
    background-color: #f2f3f5;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    // 设置第一个标签不可关闭
    .el-tabs__nav .el-tabs__item:nth-child(1) span{
      display: none;
    }
    .home {
      padding-left: 10px !important;
      font-size: 16px !important;
      height: 48px !important;
      line-height: 48px !important;
      background: rgba(0,0,0,0) !important;
      i {
        opacity: inherit;
        margin-right: 6px;
        margin-left: 14px;
        font-size: 20px;
        color: inherit;
        vertical-align: middle;
      }
      span {
        font-size: 16px;
      }
    }
    .top {
      background-color: #f2f3f5;
    }
    .hiddenBtn {
      position: absolute;
      right: -24px;
      top: 116px;
      z-index: 0;
      width: 24px;
      height: 48px;
      line-height: 48px;
      border-radius: 0 48px 48px 0;
      cursor: pointer;
      // background: -webkit-gradient(linear,left top,right top,from(#112d70),to(#205fbc));
      background: linear-gradient(90deg,#112d70,#205fbc);
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      .iconicon {
        color: #ffffff;
        font-size: 22px;
        font-weight: 700;
      }
      .el-icon-arrow-left:before {
        content: "\e6e0";
      }
      .el-icon-arrow-right:before {
        content: "\e6de";
      }
    }

    .gardenSelect {
      margin-bottom: 10px;
      width: 200px;
      margin-left: 10px;
      margin-top: 10px;
    }

    .el-container {
      height: 100%;
    }

    .el-main {
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .el-tabs__nav-wrap {
      position: fixed;
      background-color: #f2f3f5;
      width: 100%;
      z-index: 500;
      border-bottom: solid 1px #f2f3f5;
    }
    .el-tabs__nav-scroll {
      background-color: white;
      .el-tabs__nav.is-top {
        border: none;
        .el-tabs__item {
          border-left: none;
          border-right: 1px solid #e4e7ed !important;
        }
      }
    }

    .el-header {
      padding: 0px;
      height: 48px !important;
    }

    .el-menu {
      border-right: solid 0px #e6e6e6;
    }

    .el-aside {
      .el-menu-vertical-demo:last-child {
        margin-bottom: 50px;
      }
    }

    .el-menu-item i {
      vertical-align: text-top;
    }

    // .z-aside {
    //   width: 200px !important;
    //   height: 100%;
    //   background-color: $c-side-tint;
    //   color: $c-not-active;
    //   text-align: left;
    // }

    //add byzhaocx
    .sidebar{
      height: 94%;
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 1;
      margin-bottom: 20px;
      border-radius: 6px;
      // 深蓝色主题
      // background:linear-gradient(#266acc,#001f60);
      // 偏蓝色主题
      // background:linear-gradient(#00b1c3,#006d9a);
      // 粉色主题
      // background:linear-gradient(#ed8599,#c84b71);
      // 绿色主题
      // background:linear-gradient(#b4d049,#4ea00b);
    }
    // 二级菜单正常灰色度0.15
    .el-aside {
      .el-menu-vertical-demo {
        .home:first-child {
          background: rgba(0,0,0,0) !important;
        }
        .home:first-child.is-active {
          background: rgba(0,0,0,0.3) !important;
        }
      }
    }
    .el-menu-item {
      background: rgba(0,0,0,.15) !important;
    }
    .el-submenu {
      .el-submenu__title {
        padding-left: 10px !important;
        font-size: 16px !important;
        height: 48px !important;
        line-height: 48px !important;
        .iconfont {
          margin-right: 6px;
          margin-left: 14px;
          font-size: 20px;
        }
      }
    }
    // 二级菜单选中态0.3
    .el-menu-item.is-active {
      background: rgba(0,0,0,.3) !important;
    }
    .z-aside {
      width: auto !important;
      height: calc(100vh - 100px);

      // background-color: $c-side-tint;
      color: $c-not-active;
      text-align: left;
      background: url('../assets/imgs/aside.png') left bottom no-repeat;
      background-size: 100% auto;
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 220px;
      }
    }
    .el-menu-item {
      border-radius: 0px !important;
    }
    .z-aside::-webkit-scrollbar {display:none}

    .el-menu-item {
      background-color: $c-side-tint;
      color: $c-not-active;
      min-width: 0;
    }

    .el-menu-item.is-active {
      color: $c-active !important;
    }

    .el-tabs__header {
      margin: 0;
    }

    .el-container {
      height: 98%;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      border: none;
    }

    .el-tabs {
      // width: 100%;  // 切换tabs时页面被执行多次
      height: auto;
      overflow: auto;
      // min-height: 1000px;
      background-color:#f2f3f5;
    }

    .el-menu{
      background-color: transparent!important;
      border: none!important;
    }
    .el-submenu__title{
      color: #fff;
      opacity: .8;
      &:hover, &:focus{
        background-color: transparent;
      }
      .icon{
        margin-right: 20px;
      }
      i {
        color: inherit;
        opacity: inherit;
        font-size: 18px;
      }
    }
    .el-submenu:hover{
      .el-submenu__title{
        opacity: 1;
        background-color: transparent;
        border-radius: 6px;
      }
    }
    .is-opened{
      .el-submenu__title{
        opacity: 1;
        border-radius: 6px;
      }
    }

    .el-submenu .el-menu-item{
      height: 40px;
      line-height:   40px;
    }
    .el-menu-item {
      color: #fff;
      opacity: .8;
      font-size: 12px;
      border-radius: 6px;
      padding-left:20px;
      background-color: transparent;
      &.is-active, &:hover, &:focus{
        opacity: 1;
        color: #fff;
        background: rgba(0,0,0,.2);
      }
    }
    .el-submenu {
      .el-menu--inline {
        .el-menu-item {
          padding-left: 58px !important;
        }
      }
    }
    .closeTabs {
      position: absolute;
      right: 30px;
      margin-top: 10px;
      cursor: pointer;
      z-index: 700;
    }
  }
  // 删除弹框默认的透过度
  .el-loading-mask {
    background-color: hsla(0,0%,100%,0.1) !important;
  }
  .el-menu--vertical {
      background-color: #00a8bb;
      border-radius: 4px;
      ul {
        background-color: #00a8bb;
        border-radius: 4px;
        li {
          background-color: #00a8bb;
          border-radius: 4px;
          height: 40px;
          line-height: 40px;
        }
        li:hover {
          background: rgba(0,0,0,.15);
        }
      }
    }
    // 下面的css与弹框的样式有一点冲突
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    // 定义滚动条轨道 内阴影+圆角
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      // background-color: rgba(0,0,0,0.25);
    }
    // 定义滑块 内阴影+圆角
    ::-webkit-scrollbar-thumb
    {
      border-radius: 10px;
      background-color: rgba(0,0,0,0.25);
    }
    ::-webkit-scrollbar-thumb {
      border-right: 1px solid #ffffff;
   }
 
</style>
